import {
  REFRESH_CUSTOMER_ASSETS,
  SELECT_ASSET,
  ADD_HIERARCHY,
  ADD_FROM_RELATION,
  ADD_COUNTRIES,
  ADD_REGIONS,
  ADD_FACILITIES,
  ADD_CUSTOMERID,
} from './constants'

export const AddCustomerHierarchy = (hierarchy) => (dispatch) => {
  dispatch({
    type: ADD_HIERARCHY,
    payload: hierarchy,
  })
}
export const setCustomerCountries = (country) => (dispatch) => {
  dispatch({
    type: ADD_COUNTRIES,
    payload: country,
  })
}
export const setCustomerData = (customer) => (dispatch) => {
  dispatch({
    type: ADD_CUSTOMERID,
    payload: customer,
  })
}
export const setCustomerRegions = (region) => (dispatch) => {
  dispatch({
    type: ADD_REGIONS,
    payload: region,
  })
}
export const setCustomerFacilities = (facility) => (dispatch) => {
  dispatch({
    type: ADD_FACILITIES,
    payload: facility,
  })
}
export const SetAssetType = (assetType) => (dispatch) => {
  dispatch({
    type: SELECT_ASSET,
    payload: assetType,
  })
}
export const SetFromRelation = (from) => (dispatch) => {
  dispatch({
    type: ADD_FROM_RELATION,
    payload: from,
  })
}
export const RefreshCustomerAssetList = (refresh) => (dispatch) => {
  dispatch({
    type: REFRESH_CUSTOMER_ASSETS,
    payload: refresh,
  })
}
